import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}
export const Modal: React.FC<ModalProps> = ({
  title,
  children,
  onClose
}) => {
  useEffect(() => {
    // Disable scroll when modal is open
    document.body.style.overflow = 'hidden';
    // Enable scroll when modal is closed
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-250">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-hidden" data-id="element-251">
        <div className="flex items-center justify-between p-4 border-b" data-id="element-252">
          <h2 className="text-xl font-semibold text-gray-900" data-id="element-253">{title}</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700 transition duration-200" data-id="element-254">
            <XIcon className="h-6 w-6" data-id="element-255" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]" data-id="element-256">
          {children}
        </div>
      </div>
    </div>;
};